module.exports = __webpack_public_path__ + "static/see-forest-and-trees-855e547e607d0b62543e5e410e967a92.mp4";